<template>
  <div :id="id" style="height: 100%; width: 100%" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'StackedAreaChart',
  props: {
    id: {
      type: String,
      default: 'chart'
    },
    // x 轴类目（时间桶，已升序）
    xData: {
      type: Array,
      default: () => []
    },
    // 系列：[{ name, data, color }]，全部归入同一堆叠，故堆叠总高度即总量
    seriesData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById(this.id)
      const myChart = echarts.init(chartDom)
      const series = this.seriesData.map(item => {
        return {
          name: item.name,
          type: 'line',
          stack: 'total',
          smooth: true,
          symbol: 'none',
          lineStyle: { width: 1, color: item.color },
          itemStyle: { color: item.color },
          areaStyle: { color: item.color, opacity: 0.85 },
          emphasis: { focus: 'series' },
          data: item.data
        }
      })
      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true
        },
        legend: {
          data: this.seriesData.map(item => item.name)
        },
        grid: {
          left: 48,
          right: 16,
          top: 44,
          bottom: 28
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisTick: { show: false },
            data: this.xData
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: series
      }
      option && myChart.setOption(option)
      this.chart = myChart
    },
    destroyChart() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    }
  }
}
</script>

<style scoped lang="scss"></style>
